module.exports = __webpack_public_path__ + "static/img/6.677a0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/6.png
// module id = ed7o
// module chunks = 35